<template>
  <div class="graph tw:max-w-[800px] tw:m-auto tw:mt-6 tw:md:mt-10">
    <div v-for="mode in biddingModes" :key="mode">
      <div v-show="selectedCPCLevel === mode" class="tw:flex tw:items-center tw:flex-col tw:text-center tw:text-sm">
        <p>{{ $t(`rc_bidding_mode_${mode}_head`) }}</p>
        <p>{{ $t(`rc_bidding_mode_${mode}_sub`) }}</p>
        <div class="tw:mt-5 tw:flex tw:items-center">
          <InfoIcon class="tw:mr-0.5 tw:size-5" />
          {{ $t(`rc_bidding_mode_${mode}_effect`) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import InfoIcon from '@/components/icons/InfoIcon.svg?component'

defineProps({
  biddingModes: {
    type: Array,
    default: () => [],
  },
  selectedCPCLevel: {
    type: String,
    default: '',
  },
})
</script>
